module.exports = __webpack_public_path__ + "static/img/kaishu_benefit3.7bf32006.jpg";